import { Module } from 'vuex';
import { RootStoreState } from '@/store';

export interface UnifiedInsightsStoreState {
  widgets: any;
  fixDashboardWidgetsLayout: any;
  disableSaveDashboardLayout: any;
  savedDashboardLayout: any;
  selectedUserInDashboard : any;
  isReadOnlyUser: any;
}

export default {
  namespaced: true,
  state: {
    widgets: [],
    savedDashboardLayout: [],
    fixDashboardWidgetsLayout: false,
    disableSaveDashboardLayout: true,
    selectedUserInDashboard : '',
    isReadOnlyUser: false,
  },
  mutations: {
    assignWidget(state, data) {
      state.widgets = [...data];
    },
    setSavedDashboardLayout(state, data) {
      state.savedDashboardLayout = [...data];
    },
    setFixDashboardWidgetsLayout(state, data) {
      state.fixDashboardWidgetsLayout = data;
    },
    setDisableSaveDashboardLayout(state, data) {
      state.disableSaveDashboardLayout = data;
    },
    insertWidget(state, data) {
      state.widgets.push(data);
    },
    setSelectedUserInDashboard(state, data) {
      state.selectedUserInDashboard = data;
    },
    replaceWidget(state, data) {
      const newWidgetsState = [...state.widgets];
      newWidgetsState.splice(data.widgetIndex, 1, data.widgetDetails);
      state.widgets = [...newWidgetsState];
    },
    setReadOnlyUser(state, data) {
      state.isReadOnlyUser = data;
    },
  },
  actions: {
  },
  getters: {
  },
} as Module<UnifiedInsightsStoreState, RootStoreState>;
